import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { viewRewardUser, removeRewardUser } from "../../Redux/Actions/rewardsAction";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import toast from "react-hot-toast";
import "./viewReward.css";

const ViewUserRewards = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const rewardState = useSelector((state) => state.rewards || {});

  const [isRemoving, setIsRemoving] = useState(false);

  useEffect(() => {
    if (id) dispatch(viewRewardUser(id));
    else console.warn("No reward user points ID found in URL");
  }, [dispatch, id]);

  const data = rewardState.rewardHistoryDetails || {};

  const handleRemove = () => {
    if (!data._id) return;

    const confirmToastId = toast.custom((t) => (
      <div className="rewards-toast-container">
        <p className="rewards-toast-message">
          Are you sure you want to Done these reward points?
        </p>
        <div className="rewards-toast-buttons">
          <button
            onClick={() => {
              setIsRemoving(true);
              dispatch(removeRewardUser(data._id))
                .then(() => {
                  setIsRemoving(false);
                  toast.dismiss(confirmToastId);
                })
                .catch(() => {
                  setIsRemoving(false);
                  toast.dismiss(confirmToastId);
                });
            }}
            className="rewards-toast-btn rewards-toast-btn-yes"
          >
            Yes
          </button>
          <button
            onClick={() => toast.dismiss(confirmToastId)}
            className="rewards-toast-btn rewards-toast-btn-no"
          >
            No
          </button>
        </div>
      </div>
    ));
  };

  return (
    <div className="view-rewards-container">
      <div className="view-rewards-grid padding-20 gap-10 grid-container">
        <div style={{ gridColumn: "3/8" }}>
          <SearchBar style={{ width: "max-content" }} />
        </div>

        <div className="view-rewards-header back-icon margin-0 gap-10 align-center flex-container">
          <Link to="/rewards">
            <BackIcon style={{ cursor: "pointer", color: "#192135" }} />
          </Link>
          <div className="view-rewards-title-section referral-view">
            <h3 className="view-rewards-main-title">Reward User Points Details</h3>
            <h4 className="view-rewards-breadcrumb">
              Rewards / List / View
            </h4>
          </div>
        </div>

        <div className={`view-rewards-content overall-container ${isRemoving ? 'removing' : ''}`} style={{background: "#ffffff"}}>
          <div className="rewards-details-card">
            {/* Left side - Image */}
            {data.image && (
              <div className="rewards-image-section">
                <span className="rewards-image-label">Image</span>
                <img
                  src={data.image}
                  alt={data.title}
                  className="rewards-image"
                />
              </div>
            )}

            {/* Right side - Other details */}
            <div className="rewards-details-grid">
              <div className="rewards-info-grid">
                <div className="rewards-info-item">
                  <span className="rewards-info-label">Category</span>
                  <h2 className="rewards-info-value">
                    {data.category || "No Data"}
                  </h2>
                </div>

                <div className="rewards-info-item">
                  <span className="rewards-info-label">Contact Number</span>
                  <h2 className="rewards-info-value">
                    {data.contact_number || "No Data"}
                  </h2>
                </div>

                <div className="rewards-info-item rewards-points-item">
                  <span className="rewards-info-label">Reward Points</span>
                  <h2 className="rewards-info-value rewards-points-value">
                    {data.reward_points ?? "No Data"}
                  </h2>
                </div>
              </div>

              <div className="rewards-email-section">
                <div className="rewards-email-item">
                  <span className="rewards-email-label">Email</span>
                  <h2 className="rewards-email-value">
                    {data.email || "No Data"}
                  </h2>
                </div>
              </div>
            </div>
          </div>

          {/* Remove Button */}
          <div className="rewards-actions">
            <button
              onClick={handleRemove}
              disabled={isRemoving}
              className="rewards-remove-btn"
            >
              {isRemoving ? "Done..." : "Done Reward Points"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewUserRewards;